import { __decorate, __extends, __metadata } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { Misc, AppServices } from '@singularsystems/neo-core';
import ContextMenu from './ContextMenu';
/**
 * Shows the global context menu ui.
 * To show a context menu, call MenuUtils.showContextMenu
 */
var ContextMenuContainer = /** @class */ (function (_super) {
    __extends(ContextMenuContainer, _super);
    function ContextMenuContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.globalState = Misc.Globals.appService.get(AppServices.NeoTypes.UI.GlobalContextMenuState);
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        _this.onMenuItemClick = _this.onMenuItemClick.bind(_this);
        return _this;
    }
    ContextMenuContainer.prototype.componentDidMount = function () {
        window.document.addEventListener("mousedown", this.onDocumentClick);
    };
    ContextMenuContainer.prototype.componentWillUnmount = function () {
        window.document.removeEventListener("mousedown", this.onDocumentClick);
    };
    ContextMenuContainer.prototype.onDocumentClick = function (e) {
        var element = e.target;
        while (element) {
            if (element.classList.contains("neo-context-menu")) {
                return;
            }
            element = element.parentElement;
        }
        this.globalState.position = null;
    };
    ContextMenuContainer.prototype.onMenuItemClick = function () {
        this.globalState.position = null;
    };
    ContextMenuContainer.prototype.render = function () {
        var globalState = this.globalState;
        return globalState.position && React.createElement(ContextMenu, { menuItems: globalState.items, position: globalState.position, onClick: this.onMenuItemClick });
    };
    ContextMenuContainer = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], ContextMenuContainer);
    return ContextMenuContainer;
}(React.Component));
export default ContextMenuContainer;
